<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import RkMitarbeiterKostenersatz from "@/views/RK/Mitarbeiter/Kostenersatz.vue";
import { mountedBase, onSave, BaseSetup } from "@/DataLoaderStatic";
const emit = defineEmits<{
  back: [];
  calculated: [data?: any];
}>();
const props = defineProps<{
  zeitbereichUebergabe: APIZeitbereich;
  showClose?: boolean;
}>();
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_SonstigeBelege",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));

onMounted(async () => {
  pageParams.zeitbereich = props.zeitbereichUebergabe;
  await mountedBase(uiData, pageParams);
  uiData.showLoading = false;
  uiData.initialized = true;
});
</script>
<template>
  <v-sheet class="pa-0">
    <v-progress-linear
      :indeterminate="true"
      v-if="uiData.showLoading"
      color="dvhSlider"
    ></v-progress-linear>
    <v-expansion-panels class="pa-0" rounded="0">
      <v-expansion-panel v-if="uiData.initialized">
        <v-expansion-panel-title
          disable-icon-rotate
          class="subtitle-1 dvhBackground lighten-2 white--text"
        >
          <span style="color: white">{{ uiData.header.bezeichnung }}</span>

          <template v-slot:actions>
            <v-icon color="white">$expand</v-icon>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text class="pa-0">
          <RkMitarbeiterKostenersatz
            ref="timelines"
            query="Web_SonstigeBelege"
            editQuery="Web_NeuerSonstigerBeleg"
            :zeitbereich="props.zeitbereichUebergabe"
            :backOnSave="false"
          ></RkMitarbeiterKostenersatz>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-sheet>
</template>
<style scoped>
.dvhCol {
  padding-right: 0px;
  padding-left: 10px;
  padding-top: 15px;
  padding-bottom: 0px;
}
</style>
